var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 25.503 25.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M72.808,68.751A12.751,12.751,0,1,1,85.559,56,12.766,12.766,0,0,1,72.808,68.751m0-24.121A11.37,11.37,0,1,0,84.177,56,11.383,11.383,0,0,0,72.808,44.63M71.439,58.188a3.8,3.8,0,0,1,1.547-2.726,3.552,3.552,0,0,0,1.548-2.283c0-.866-.626-1.345-1.677-1.345a2.253,2.253,0,0,0-2.192,1.639l-2.172-1.252a4.637,4.637,0,0,1,4.457-2.855,4.5,4.5,0,0,1,2.89.976,3.168,3.168,0,0,1,1.236,2.652c0,2.744-3.1,3.592-3.1,5.194Zm.165,4.107a1.563,1.563,0,1,1,2.21,0,1.569,1.569,0,0,1-2.21,0",
    transform: "translate(-60.056 -43.249)",
    fill: "#8a8fb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMark);
export default __webpack_public_path__ + "static/media/icon-question-mark.14dd63b294e738d6b686604ecdffc8eb.svg";
export { ForwardRef as ReactComponent };